import { AxiosResponse } from 'axios';
import api from './api';
import Category from '../models/Category/Category';
import { PaginationLinks, PaginationMeta } from '../components/Modals/Paginator';

type CategoryCreateRequest = Omit<Category, 'id'>;

declare type GetCategoriesType = {
  data: Category[]
  meta: PaginationMeta
  links: PaginationLinks
};

export const get = async () => api.get<GetCategoriesType>('v1/page_template_categories');

export const post = async (data: CategoryCreateRequest): Promise<AxiosResponse<string>> => api.post<string>('v1/page_template_categories/create', data);

export const put = async (data: Category) => api.post(`v1/page_template_categories/${data.id}/update`, data);

export const destroy = async (id: string) => api.post(`v1/page_template_categories/${id}/delete`, {});

export default {
  get,
  post,
  put,
  destroy,
};
